import React from 'react'

/**
 * The Share Page Info Block component
 * Displays an informational block with subtitle, title, and text content.
 *
 * @param {Object} props - Component props
 * @param {Immutable.Map} props.staticText - Immutable Map containing strings
 * @returns {JSX.Element} Informational content block component
 */
function SharePageInfoBlock (props) {
  const { staticText } = props

  return (
    <div className="share-page__info-block">
      <div className="share-page__info-block-overlay" />
      <div className="share-page__info-block-content">
        <div className="share-page__subtitle share-page__info-block-subtitle">{staticText.get('infoBlockSubtitle')}</div>
        <div className="share-page__info-block-title">{staticText.get('infoBlockTitle')}</div>
        <div className="share-page__info-block-text">{staticText.get('infoBlockText')}</div>
      </div>
    </div>
  )
}

export default SharePageInfoBlock
